import * as styles from '../../../ap/base/styles';
import * as typestyle from 'typestyle';
import {InputStyles} from "../../../ap/base/input";

export function buildAddressLookupTheme(isError: boolean) {

  const borderColorNormal = styles.colors.warmGrey3;
  const borderColorOnFocus = styles.colors.warmGrey4;
  const borderColor = styles.colors.grey;
  const backgroundColor = '#fff';
  const highlightBackgroundColor = styles.colors.warmGrey2;
  const highlightBorderColor = '#dad0ca';

  const inputColor = isError ? InputStyles.errorColor : borderColor;
  const inputBorderColor = isError ? InputStyles.errorColor : borderColorNormal;
  const inputBorderColorOnFocus = isError ? InputStyles.errorColor : borderColorOnFocus;

  const inputStyle = {
    width: '100%',
    height: '40px',
    padding: '7px 10px',
    outline: `none`,
    color: `${inputColor}`,
    background: `${backgroundColor}`,
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '3px',
    '&:active': {
      border: `2px solid ${inputBorderColorOnFocus}`,
      padding: '6px 9px'
    },
    '&:hover': {
      border: `1px solid ${inputBorderColorOnFocus}`,
      padding: '7px 10px'
    },
    '&:focus': {
      border: `2px solid ${inputBorderColorOnFocus}`,
      padding: '6px 9px'
    }
  };

  const dropDownStyle = {
    border: `1px solid ${highlightBorderColor}`,
    borderRadius: '2px',
    cursor: 'pointer',
    zIndex: 9999,
    width: '100%',
    backgroundColor: `${backgroundColor}`,
    boxShadow: '-1px 7px 4px 0px rgba(0, 0, 0, 0.42)',
    color: `${borderColor}`
  };

  const listStyle = {
    listStyleType: 'none',
    lineHeight: '1.4',
    padding: '0px 0px',
    marginTop: '0px',
    marginBottom: '0px'
  };

  const suggestionItemStyle = {
    padding: '5px 10px'
  };

  const containerStyle = {
    width: '100%',
    padding: '0px 0px',
  };

  const selectionStyle = {
    backgroundColor: `${highlightBackgroundColor}`
  };

  const addressLookupTheme = {
    container: typestyle.style(containerStyle),
    containerOpen: typestyle.style(containerStyle),
    input: typestyle.style(inputStyle),
    suggestionsContainerOpen: typestyle.style(dropDownStyle),
    suggestionsList: typestyle.style(listStyle),
    suggestionHighlighted: typestyle.style(selectionStyle),
    suggestion: typestyle.style(suggestionItemStyle),
  };

  return addressLookupTheme;
}

